import axios from "axios";

export default axios.create({
  baseURL: process.env.VUE_BACKEND_URI || '/api',
  headers: {
    "Content-type": "application/json"
  }
});